import { heroBannerSlideshowProjection } from './pageBuilderProjection';
import { namespaceType } from './namespace';

const articlesListType = namespaceType('articlesList');

export const ARTICLES_LIST_CONFIG_QUERY = `
  *[_type == "${articlesListType}" && type == $type][0] {
    ...,
    heroBanner{
      ${heroBannerSlideshowProjection}
    }
  }
`;
